import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import EmptyState from './empty_state';
import View from './view';

import './styles.scss';

export function ListingTab({ deal }) {
  if (!deal.listing && !deal.project) {
    return <EmptyState />;
  }

  return <View/>;
}

ListingTab.propTypes = {
  deal: PropTypes.shape({
    listing: PropTypes.object,
    project: PropTypes.object
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(ListingTab);
